export default {
    path: '/student',
    components: {
        default: () => import(/* webpackChunkName: "student" */ '../views/ChildContainer'),
        menu: () => import(/* webpackChunkName: "student-menu" */ '../views/student/Menu'),
    },
    children: [
        {
            path: '',
            name: 'StudentHome',
            component: () => import(/* webpackChunkName: "student-home" */ '../views/Home'),
        },
        {
            path: 'info-edit',
            name: 'StudentInfoEdit',
            component: () => import(/* webpackChunkName: "student-info-edit" */ '../views/student/StudentInfoEdit'),
        },
        {
            path: 'signInManage',
            name: 'StudentSignInManage',
            component: () => import(/* webpackChunkName: "student-signin-manage" */ '../views/student/StudentSignInManage'),
        },
        {
            path: 'surveyManage',
            name: 'StudentSurveyManage',
            component: () => import(/* webpackChunkName: "student-survey-manage" */ '../views/student/StudentSurveyManage'),
        },
        {
            path: 'surveyPaperEdit/:surveyPaperId',
            name: 'StudentSurveyPaperEdit',
            component: () => import(/* webpackChunkName: "student-survey-paper-edit" */ '../views/student/StudentSurveyPaperEdit'),
        },
        {
            path: 'studyClassManage',
            name: 'StudentStudyClassManage',
            component: () => import(/* webpackChunkName: "student-study-class-manage" */ '../views/student/StudentStudyClassManage'),
        },
        {
            path: 'messageManage',
            name: 'StudentMessageManage',
            component: () => import(/* webpackChunkName: "student-message-manage" */ '../views/student/StudentMessageManage'),
        },
        {
            path: 'certificateManage',
            name: 'StudentCertificateManage',
            component: () => import(/* webpackChunkName: "student-certificate-manage" */ '../views/student/StudentCertificateManage'),
        },
    ]
}